import React from "react"
import { Col, Row, Visible } from "react-grid-system"
import styled from "styled-components"
import { SignalQualityWithZero } from "../../../types"
import SignalStrengthBars from "../../atoms/graphs/SignalStrengthBars"
import { HorizontalSpacer } from "../../atoms/spacers"
import H2 from "../../atoms/typography/H2"
import H4 from "../../atoms/typography/H4"
import { useTheme } from "styled-components"

const GraphContainerCol = styled(Col)`
  min-width: 210px;
  max-width: 250px;
`

const ColWithMaxWidth = styled(Col)`
  max-width: 120px !important;
`

const SignalQualityChart: React.FunctionComponent<{ signalQuality?: SignalQualityWithZero }> = (props) => {
  const theme = useTheme()

  const signalQualityToWord = (strength: SignalQualityWithZero) => {
    switch (strength) {
      case 0:
        return "No signal"
      case 1:
        return "Low"
      case 2:
        return "Medium"
      case 3:
        return "High"
      case 4:
        return "Very High"
    }
  }

  return (
    <GraphContainerCol>
      <Row align="center" justify="center">
        <ColWithMaxWidth xs={6}>
          <SignalStrengthBars strength={props.signalQuality ?? 0} />
        </ColWithMaxWidth>
        <ColWithMaxWidth xs={6}>
          <H2 color={props.signalQuality !== undefined ? theme.colors.greyDark : theme.colors.greyDisabled}>
            {props.signalQuality !== undefined ? signalQualityToWord(props.signalQuality) : "--"}
          </H2>
        </ColWithMaxWidth>
      </Row>
      <Visible xs sm>
        <HorizontalSpacer spacing={2} />
      </Visible>
    </GraphContainerCol>
  )
}

export default SignalQualityChart
